module.exports = __webpack_public_path__ + "static/media/ordinal-numbers-german.3dcaa4cd.PNG";